module.exports = __webpack_public_path__ + "img/f6-2-2.5da3c2a8.png";